import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { TrackedArray } from 'tracked-built-ins';

export default class DebugLiveBuildStatusLogsController extends Controller {
  queryParams = ['searchTerm', 'beginDate', 'endDate', 'stationIds', 'page'];

  @tracked showJsonModal = false;
  @tracked model = new TrackedArray();
  @tracked displayedLog;
  @tracked searchTerm;
  @tracked beginDate;
  @tracked endDate;
  @tracked stationIds = [];
  @tracked page = 1;

  @action
  onShowJsonModal(obj) {
    if (obj == null) {
      return;
    }

    Object.assign(this, {
      showJsonModal: true,
      displayedLog: obj,
    });
  }

  @action
  onParamChange(key, value) {
    this[key] = value;
  }
}
